export const BUSINESS_PERFORMANCE = {
    profit: {
        en: 'Earned a profit',
        es: 'Obtuvo ganancias'
    },
    loss: {
        en: 'Took a loss',
        es: 'Sufrió pérdidas'
    },
    even: {
        en: 'Broke even',
        es: 'En punto de equilibrio'
    },
    noop: {
        en: 'My business was not operating at the time',
        es: 'Mi negocio no estaba operando en ese momento'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
